import React, { useEffect, useState } from "react";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";
import customerService from "../services/customerService";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import '../styles/phone-input.scss';

const CustomerProfilePage = () => {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [profileData, setProfileData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    isNewsletterSubscribed: false
  });
  
  // Form değişikliğini izlemek için state'ler
  const [initialProfileData, setInitialProfileData] = useState(null);
  const [isProfileChanged, setIsProfileChanged] = useState(false);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  
  // Şifre değiştirme state'leri
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: ""
  });
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const data = await customerService.getCustomerProfile();
        
        // Telefon numarasını işle
        let phoneNumber = data.phoneNumber || "";
        
        setProfileData({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          email: data.email || "",
          phoneNumber: phoneNumber,
          isNewsletterSubscribed: data.isNewsletterSubscribed || false
        });
        
        setInitialProfileData({
          firstName: data.firstName || "",
          lastName: data.lastName || "",
          email: data.email || "",
          phoneNumber: phoneNumber,
          isNewsletterSubscribed: data.isNewsletterSubscribed || false
        });
        
        setLoading(false);
      } catch (error) {
        console.error("Profil bilgileri alınırken hata oluştu:", error);
        setError("Profil bilgileri alınırken hata oluştu. Lütfen daha sonra tekrar deneyin.");
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setProfileData({
      ...profileData,
      [e.target.name]: value,
    });
  };

  // Şifre değiştirme inputları için handleChange
  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value
    });
  };

  // Telefon numarası değiştiğinde
  const handlePhoneChange = (value) => {
    setProfileData({
      ...profileData,
      phoneNumber: value
    });
  };

  // Formun gönderilmesi
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccessMessage("");
    
    // Kullanıcı bilgilerini kontrol et
    if (!user || !user.id) {
      setError("Kullanıcı bilgileri bulunamadı. Lütfen tekrar giriş yapın.");
      return;
    }
    
    console.log("Kullanıcı ID:", user.id);
    
    // Telefon numarasını API'ye gönderilecek formatta düzenle
    const dataToSubmit = { ...profileData };
    
    // Kullanıcı ID'sini ekle
    dataToSubmit.userId = user.id;
    
    console.log("Gönderilecek veri:", dataToSubmit);
    
    try {
      const result = await customerService.updateCustomerProfile(dataToSubmit);
      if (result.succeeded) {
        setSuccessMessage("Profil bilgileriniz başarıyla güncellendi.");
        setInitialProfileData({...profileData});
        setIsProfileChanged(false);
        window.scrollTo(0, 0);
      } else {
        setError(result.message || "Profil güncellenirken bir hata oluştu");
      }
    } catch (error) {
      console.error("Profil güncelleme hatası:", error.response?.data || error);
      setError("Profil güncellenirken bir hata oluştu: " + (error.message || error));
    }
  };

  // Şifre değiştirme formunun gönderilmesi
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setPasswordError("");
    setPasswordSuccess("");
    
    // Şifre doğrulaması
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setPasswordError("Yeni şifre ve şifre tekrarı eşleşmiyor.");
      return;
    }
    
    // Şifre kompleks mi kontrolü
    if (passwordData.newPassword.length < 8) {
      setPasswordError("Şifreniz en az 8 karakter uzunluğunda olmalıdır.");
      return;
    }
    
    try {
      // API çağrısı
      const result = await customerService.changePassword({
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword
      });
      
      if (result.succeeded) {
        setPasswordSuccess("Şifreniz başarıyla değiştirildi.");
        // Şifre alanlarını temizle
        setPasswordData({
          currentPassword: "",
          newPassword: "",
          confirmPassword: ""
        });
        setIsPasswordChanged(false);
      } else {
        setPasswordError(result.message || "Şifre değiştirilirken bir hata oluştu");
      }
    } catch (error) {
      setPasswordError("Şifre değiştirilirken bir hata oluştu: " + (error.message || error));
    }
  };

  // Form değişikliklerini kontrol eden fonksiyon
  const checkProfileChanges = () => {
    if (!initialProfileData) return false;
    
    // Formların içeriğini karşılaştır
    return (
      initialProfileData.firstName !== profileData.firstName ||
      initialProfileData.lastName !== profileData.lastName ||
      initialProfileData.email !== profileData.email ||
      initialProfileData.phoneNumber !== profileData.phoneNumber ||
      initialProfileData.isNewsletterSubscribed !== profileData.isNewsletterSubscribed
    );
  };

  // Şifre alanlarının dolu olup olmadığını kontrol et
  const checkPasswordFields = () => {
    return (
      passwordData.currentPassword.trim() !== '' &&
      passwordData.newPassword.trim() !== '' &&
      passwordData.confirmPassword.trim() !== ''
    );
  };

  // Başlangıçtaki profil verilerini kaydet
  useEffect(() => {
    if (initialProfileData) {
      setIsProfileChanged(checkProfileChanges());
    }
  }, [profileData, initialProfileData]);

  // Şifre alanlarındaki değişikliği kontrol et
  useEffect(() => {
    setIsPasswordChanged(checkPasswordFields());
  }, [passwordData]);

  return (
    <>
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <Preloader />
      <HeaderOne />
      <Breadcrumb title={"Müşteri Profili"} />

      <div className="login-area pt-100 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            {/* Profil Bilgileri Formu - Sol Kolon */}
            <div className="col-lg-6">
              <div className="login-form-wrapper">
                <h3>Profil Bilgilerim</h3>
                
                {loading ? (
                  <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : (
                  <>
                    {error && <div className="alert alert-danger">{error}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    
                    <form onSubmit={handleSubmit} className="login-form">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="single-input-item">
                            <label>Ad *</label>
                            <input
                              type="text"
                              name="firstName"
                              placeholder="Adınızı giriniz"
                              value={profileData.firstName || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="single-input-item">
                            <label>Soyad *</label>
                            <input
                              type="text"
                              name="lastName"
                              placeholder="Soyadınızı giriniz"
                              value={profileData.lastName || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div className="single-input-item">
                            <label>E-posta Adresi *</label>
                            <input
                              type="email"
                              name="email"
                              placeholder="E-posta adresinizi giriniz"
                              value={profileData.email || ""}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="single-input-item">
                            <label>Telefon Numarası</label>
                            <PhoneInput
                              country={'tr'}
                              value={profileData.phoneNumber}
                              onChange={handlePhoneChange}
                              inputClass="form-control"
                              containerStyle={{width: '100%'}}
                              inputStyle={{width: '100%', height: '45px'}}
                              buttonStyle={{borderTopLeftRadius: '4px', borderBottomLeftRadius: '4px'}}
                              placeholder="Telefon numaranızı giriniz"
                              enableSearch={false}
                              countryCodeEditable={false}
                              preferredCountries={['tr', 'us', 'gb', 'de', 'fr']}
                            />
                            <small className="form-text text-muted">Örnek: 5XX XXX XX XX</small>
                          </div>
                        </div>
                      </div>

                      <div className="single-input-item checkbox-item">
                        <input 
                          type="checkbox" 
                          id="newsletter" 
                          name="isNewsletterSubscribed"
                          checked={profileData.isNewsletterSubscribed || false}
                          onChange={handleChange}
                        />
                        <label htmlFor="newsletter">
                          Kampanya ve fırsatlardan haberdar olmak istiyorum
                        </label>
                      </div>

                      <div className="single-input-item">
                        <button 
                          type="submit" 
                          className="btn-hover login-btn" 
                          disabled={!isProfileChanged}
                          style={{
                            backgroundColor: isProfileChanged ? '#299E60' : '#cccccc',
                            cursor: isProfileChanged ? 'pointer' : 'not-allowed',
                            opacity: isProfileChanged ? 1 : 0.7
                          }}
                        >
                          Profili Güncelle
                        </button>
                      </div>
                    </form>
                  </>
                )}
              </div>
            </div>
            
            {/* Şifre Değiştirme Formu - Sağ Kolon */}
            <div className="col-lg-6">
              <div className="login-form-wrapper">
                <h3>Şifre Değiştir</h3>
                
                {passwordError && <div className="alert alert-danger">{passwordError}</div>}
                {passwordSuccess && <div className="alert alert-success">{passwordSuccess}</div>}
                
                <form onSubmit={handlePasswordSubmit} className="login-form">
                  <div className="single-input-item">
                    <label>Mevcut Şifre *</label>
                    <input
                      type="password"
                      name="currentPassword"
                      placeholder="Mevcut şifrenizi giriniz"
                      value={passwordData.currentPassword}
                      onChange={handlePasswordChange}
                      required
                    />
                  </div>
                  
                  <div className="single-input-item">
                    <label>Yeni Şifre *</label>
                    <input
                      type="password"
                      name="newPassword"
                      placeholder="Yeni şifrenizi giriniz"
                      value={passwordData.newPassword}
                      onChange={handlePasswordChange}
                      required
                    />
                    <small className="form-text text-muted">Şifreniz en az 8 karakter uzunluğunda olmalıdır.</small>
                  </div>
                  
                  <div className="single-input-item">
                    <label>Yeni Şifre Tekrar *</label>
                    <input
                      type="password"
                      name="confirmPassword"
                      placeholder="Yeni şifrenizi tekrar giriniz"
                      value={passwordData.confirmPassword}
                      onChange={handlePasswordChange}
                      required
                    />
                  </div>
                  
                  <div className="single-input-item">
                    <button 
                      type="submit" 
                      className="btn-hover login-btn" 
                      disabled={!isPasswordChanged}
                      style={{
                        backgroundColor: isPasswordChanged ? '#299E60' : '#cccccc',
                        cursor: isPasswordChanged ? 'pointer' : 'not-allowed',
                        opacity: isPasswordChanged ? 1 : 0.7
                      }}
                    >
                      Şifremi Değiştir
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ShippingOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default CustomerProfilePage; 